import React, {
  useEffect,
  useState,
  useCallback
} from "react";
import uiConfig from "../config/uiConfig";


import {
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";


import AddIcon from "@mui/icons-material/Add";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";


import TicketTable from "../components/tickets/TicketTable";
import TicketDialog from "../components/tickets/TicketDialog";
import DeleteDialog from "../components/tickets/DeleteDialog";
import TicketFilters from "../components/tickets/TicketFilters";


import {
  getTickets,
  createTicket,
  updateTicket,
  deleteTicket,
} from "../services/ticketService";
import { useUserRole } from "../context/UserRoleContext";
import { USER_ROLES } from "../auth/roles";


function Tickets(){



const [tickets,setTickets] = useState([]);

const [loading,setLoading] = useState(false);



// FILTER STATES

const [search,setSearch] = useState("");

const [status,setStatus] = useState("");

const [priority,setPriority] = useState("");

const [category,setCategory] = useState("");

const [sortBy,setSortBy] = useState("");





const [dialogOpen,setDialogOpen] = useState(false);

const [isSaving,setIsSaving] = useState(false);

const [deleteOpen,setDeleteOpen] = useState(false);

const [isDeleting,setIsDeleting] = useState(false);
const [isBulkDeleting,setIsBulkDeleting] = useState(false);
const [bulkDeleteOpen,setBulkDeleteOpen] = useState(false);
const [deleteRelated,setDeleteRelated] = useState(false);
const [selectedTicketIds,setSelectedTicketIds] = useState([]);


const [selectedTicket,setSelectedTicket] = useState(null);






const [snackbar,setSnackbar] = useState({

open:false,

message:"",

severity:"success"

});

const {
  role,
  employee,
  loading: roleLoading
} = useUserRole();









const loadTickets = useCallback(async()=>{


try{


setLoading(true);



const data = await getTickets(

search,

status,

priority,

category,

sortBy,

role === USER_ROLES.SUPER_ADMIN
? null
: (employee?.employee_id ?? -1)

);



setTickets(data);

setSelectedTicketIds((prev) => {
  const validIds = new Set(data.map((ticket) => ticket.ticket_id));
  return prev.filter((id) => validIds.has(id));
});



}

catch(error){


console.error(

"Ticket Load Error:",

error.response?.data || error

);



setSnackbar({

open:true,

message:"Failed to load tickets",

severity:"error"

});


}


finally{


setLoading(false);


}



},[

search,

status,

priority,

category,

sortBy,

role,

employee

]);









useEffect(()=>{

if(roleLoading){
  return;
}


loadTickets();


},[loadTickets, roleLoading]);









const handleSave = async(data)=>{

if(isSaving){
return;
}

try{

setIsSaving(true);

if(selectedTicket){



await updateTicket(

selectedTicket.ticket_id,

data

);



}

else{


const creatorEmployeeId = data.created_by || employee?.employee_id;

if(!creatorEmployeeId){
  throw new Error("Unable to resolve logged-in employee. Please map your login email to an employee record.");
}



await createTicket({

...data,

created_by:creatorEmployeeId

});



}





await loadTickets();



setDialogOpen(false);

setSelectedTicket(null);




setSnackbar({

open:true,

message:"Ticket saved successfully",

severity:"success"

});




}

catch(error){



console.error(

"Ticket Save Error:",

error.response?.data || error

);

const message = (
error?.response?.data?.detail
|| error?.message
|| "Operation failed"
);



setSnackbar({

open:true,

message,

severity:"error"

});


}

finally{

setIsSaving(false);

}



};









const handleDelete = async()=>{

if(!selectedTicket || isDeleting){
return;
}

const closeDeleteDialog = ()=>{
setDeleteOpen(false);
setSelectedTicket(null);
setDeleteRelated(false);
};


try{

setIsDeleting(true);


await deleteTicket(

  selectedTicket.ticket_id,

  deleteRelated

);

closeDeleteDialog();




await loadTickets();




setSnackbar({

open:true,

message:deleteRelated
? "Ticket and related records deleted successfully"
: "Ticket deleted successfully",

severity:"success"

});



}

catch(error){



console.error(

"Delete Error:",

error.response?.data || error

);

closeDeleteDialog();


const message = (
error?.response?.data?.detail
|| "Delete failed"
);



setSnackbar({

open:true,

message,

severity:"error"

});


}

finally{

setIsDeleting(false);

}



};




const handleBulkDelete = async()=>{

if(selectedTicketIds.length === 0 || isBulkDeleting){
return;
}

try{

setIsBulkDeleting(true);

let successCount = 0;
let failedCount = 0;

for(const ticketId of selectedTicketIds){
try{
await deleteTicket(ticketId, true);
successCount += 1;
}catch(error){
failedCount += 1;
}
}

setBulkDeleteOpen(false);
await loadTickets();
setSelectedTicketIds([]);

setSnackbar({
open:true,
message:failedCount === 0
? `${successCount} ticket(s) deleted successfully`
: `${successCount} deleted, ${failedCount} failed`,
severity:failedCount === 0 ? "success" : "warning"
});

}catch(error){

console.error("Bulk Delete Error:", error);
setBulkDeleteOpen(false);
setSnackbar({
open:true,
message:"Bulk delete failed",
severity:"error"
});

}finally{

setIsBulkDeleting(false);

}

};









return (


<Box

sx={{

bgcolor:"background.default",

minHeight:"100vh",


p:3

}}

>






{/* HEADER */}



<Box

display="flex"

justifyContent="space-between"

alignItems="center"

mb={3}

>



<Box>


<Typography

variant="h4"

fontWeight={600}

color="text.primary"

>

Tickets

</Typography>





<Typography

fontSize={14}

color="text.secondary"

>

Manage and track all IT support requests.

</Typography>



</Box>

<Box display="flex" alignItems="center" gap={1.2}>









<Button
variant="outlined"
color="error"
startIcon={isBulkDeleting ? <CircularProgress size={16} color="inherit" /> : <DeleteSweepIcon />}
onClick={()=>setBulkDeleteOpen(true)}
disabled={selectedTicketIds.length === 0 || isBulkDeleting}
sx={{ height:38, textTransform:"none", borderRadius:2, px:2 }}
>
{isBulkDeleting ? "Deleting..." : `Delete All (${selectedTicketIds.length})`}
</Button>

<Button

variant="contained"

startIcon={<AddIcon/>}

onClick={()=>{


setSelectedTicket(null);

setDialogOpen(true);


}}

sx={{

background:uiConfig.buttonColor,

textTransform:"none",

fontWeight:600,

height:38,

px:3,

borderRadius:2

}}

>

Create Ticket

</Button>

</Box>





</Box>









{/* FILTERS */}



<TicketFilters


search={search}

setSearch={setSearch}


status={status}

setStatus={setStatus}


priority={priority}

setPriority={setPriority}


category={category}

setCategory={setCategory}


sortBy={sortBy}

setSortBy={setSortBy}



onApply={loadTickets}




onReset={()=>{


setSearch("");

setStatus("");

setPriority("");

setCategory("");

setSortBy("");

loadTickets();


}}


/>









{/* TABLE */}



<TicketTable


tickets={tickets}


loading={loading}


selectedIds={selectedTicketIds}
onSelectionChange={setSelectedTicketIds}



onEdit={(ticket)=>{


setSelectedTicket(ticket);

setDialogOpen(true);


}}



onDelete={(ticket)=>{


setSelectedTicket(ticket);

setDeleteRelated(false);

setDeleteOpen(true);


}}


/>



<Dialog
open={bulkDeleteOpen}
onClose={()=>{
if(!isBulkDeleting){
setBulkDeleteOpen(false);
}
}}
disableEscapeKeyDown={isBulkDeleting}
maxWidth="xs"
fullWidth
>
<DialogTitle>Delete Selected Tickets</DialogTitle>
<DialogContent>
<DialogContentText>
Are you sure you want to delete all selected tickets?
<br />
<br />
Selected: <strong>{selectedTicketIds.length}</strong>
<br />
This will remove related records for each selected ticket.
</DialogContentText>
</DialogContent>
<DialogActions>
<Button
variant="outlined"
onClick={()=>setBulkDeleteOpen(false)}
disabled={isBulkDeleting}
>
Cancel
</Button>
<Button
variant="contained"
color="error"
onClick={handleBulkDelete}
disabled={isBulkDeleting}
startIcon={
isBulkDeleting
? <CircularProgress size={16} color="inherit" />
: <DeleteSweepIcon />
}
>
{isBulkDeleting ? "Deleting..." : "Delete All"}
</Button>
</DialogActions>
</Dialog>









{/* CREATE / UPDATE */}



<TicketDialog


open={dialogOpen}


ticket={selectedTicket}

deleteRelated={deleteRelated}

onToggleDeleteRelated={setDeleteRelated}

isSaving={isSaving}



onClose={()=>{

if(isSaving){
return;
}

setDialogOpen(false);

setSelectedTicket(null);


}}



onSave={handleSave}


/>









{/* DELETE */}



<DeleteDialog


open={deleteOpen}

isDeleting={isDeleting}


ticket={selectedTicket}



onClose={()=>{

if(isDeleting){
return;
}


setDeleteOpen(false);

setSelectedTicket(null);

setDeleteRelated(false);


}}



onConfirm={handleDelete}


/>









{/* MESSAGE */}



<Snackbar


open={snackbar.open}


autoHideDuration={4000}



onClose={()=>setSnackbar({

...snackbar,

open:false

})}



>


<Alert severity={snackbar.severity}>


{snackbar.message}


</Alert>


</Snackbar>









</Box>


);


}



export default Tickets;